import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Loiresults from "../../../Components/Recherche/results_search/ResultTextDeLois/LoisResult/loiresult";
import NoLoisResult from "../../../Components/Recherche/results_search/ResultTextDeLois/NoLoisResult/NoLoisResult";
import Logo from "../../../Assets/logo.png";
import { nextPageGet, previousPageGet } from "../../../utils/pagination";
import FiltreLois from "../../../Components/Recherche/results_search/ResultTextDeLois/FiltreLois/FiltreLois";
import "./loiesresult.css";

const AllLoiResults = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const searchParams = new URLSearchParams(location.search);
    const initialQuery = searchParams.get("query") || "";
    const pageParam = searchParams.get("page") || "1";

    const [searchInput, setSearchInput] = useState(initialQuery);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [activeFilter, setActiveFilter] = useState("Articles");
    const [currentQuery, setCurrentQuery] = useState(initialQuery);
    const [currentPage, setCurrentPage] = useState(parseInt(pageParam, 10));
    const itemsPerPage = 20;
    const [searchData, setSearchData] = useState({
        count: 0,
        next: null,
        previous: null,
        results: [],
    });
    const [legalCategories, setLegalCategories] = useState({});
    const [legalCategoriesPage, setLegalCategoriesPage] = useState(1);
    const [legalCategoriesLoading, setLegalCategoriesLoading] = useState(false);

    useEffect(() => {
        const searchParams = new URLSearchParams(location.search);
        const query = searchParams.get("query") || "";
        const pageParam = searchParams.get("page") || "1";

        setCurrentQuery(query);
        setCurrentPage(parseInt(pageParam, 10));

        if (query) {
            setSearchInput(query);
        }
    }, [location.search]);

    useEffect(() => {
        if (currentQuery) {
            fetchResults(currentQuery, currentPage);
        } else {
            fetchLegalCategories(legalCategoriesPage);
        }
    }, [currentQuery, currentPage]);

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        params.set("page", currentPage.toString());

        window.history.pushState(
            {},
            "",
            `${location.pathname}?${params.toString()}`
        );
    }, [currentPage, location.search]);

    const fetchLegalCategories = async (page = 1) => {
        setLegalCategoriesLoading(true);
        setError(null);

        try {
            const url = `${process.env.REACT_APP_API_URL}/lois/legaltext/all/?page=${page}`;
            const response = await fetch(url, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                },
            });

            if (!response.ok) {
                throw new Error(
                    "Une erreur est survenue lors de la récupération des catégories juridiques."
                );
            }

            const data = await response.json();
            setLegalCategories(data);
            setLegalCategoriesPage(page);
        } catch (err) {
            setError(err.message);
            console.error("Erreur lors du chargement des catégories:", err);
        } finally {
            setLegalCategoriesLoading(false);
        }
    };

    const handleCategoriesPageChange = (page) => {
        fetchLegalCategories(page);
    };

    const fetchResults = async (query, page = 1) => {
        if (!query) return;

        setLoading(true);
        setError(null);
        setCurrentQuery(query);
        setCurrentPage(page);

        try {
            const url = `${process.env.REACT_APP_API_URL}/lois/es/simple-search/?query=${query}&page=${page}&limit=${itemsPerPage}`;

            const response = await fetch(url, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                },
            });

            if (!response.ok) {
                throw new Error(
                    "Une erreur est survenue lors de la récupération des données."
                );
            }

            const data = await response.json();

            const formattedData = {
                count: data.count || (data.length > 0 ? data.length : 0),
                next: data.next || null,
                previous: data.previous || null,
                results: Array.isArray(data) ? data : data.results || [],
            };

            setSearchData(formattedData);
        } catch (err) {
            setError(err.message);

            setSearchData({
                count: 0,
                next: null,
                previous: null,
                results: [],
            });
        } finally {
            setLoading(false);
        }
    };

    const handleSearch = (e) => {
        e.preventDefault();
        if (searchInput.trim()) {
            const params = new URLSearchParams(location.search);
            params.set("query", searchInput.trim());
            params.set("page", "1");

            window.history.pushState(
                {},
                "",
                `${location.pathname}?${params.toString()}`
            );

            fetchResults(searchInput.trim(), 1);
        }
    };

    const handleFilterClick = (filter) => {
        setActiveFilter(filter);
        setSearchInput(filter);

        const params = new URLSearchParams(location.search);
        params.set("query", filter);
        params.set("page", "1");

        window.history.pushState(
            {},
            "",
            `${location.pathname}?${params.toString()}`
        );

        fetchResults(filter, 1);
    };

    const handlePageChange = async (page) => {
        setCurrentPage(page);

        const params = new URLSearchParams(location.search);
        params.set("page", page.toString());
        window.history.pushState(
            {},
            "",
            `${location.pathname}?${params.toString()}`
        );

        try {
            setLoading(true);

            if (searchData.next && page > currentPage) {
                const data = await nextPageGet(searchData.next);
                setSearchData({
                    count: data.count || (data.results ? data.results.length : 0),
                    results: data.results || [],
                    next: data.next,
                    previous: data.previous,
                });
            } else if (searchData.previous && page < currentPage) {
                const data = await previousPageGet(searchData.previous);
                setSearchData({
                    count: data.count || (data.results ? data.results.length : 0),
                    results: data.results || [],
                    next: data.next,
                    previous: data.previous,
                });
            } else {
                fetchResults(currentQuery, page);
            }
        } catch (err) {
            console.error("Erreur lors du changement de page:", err);
        } finally {
            setLoading(false);
        }
    };

    const handleLogin = () => {
        window.location.href = "https://datagreffe.ci/dashboard";
    };

    const filters = [
        "contrat",
        "civil",
        "obligation",
        "état civil",
        "rectification",
        "erreur",
        "registre",
        "société",
        "capital variable",
        "responsabilité",
        "dommage",
        "réparation",
        "négligence",
        "imprudence",
        "propriété",
        "droit réel",
        "bien",
    ];

    return (
        <div className="lois-page">
            {/* Header */}
            <header className="lois-header">
                <div className="lois-header-left">
                    <Link to="/" className="lois-logo-link">
                        <div className="lois-logo-badge">DG</div>
                        <span className="lois-logo-text">Datagreffe justice</span>
                    </Link>
                </div>

                <div className="lois-search-container">
                    <form onSubmit={handleSearch} className="lois-search-form">
                        <span className="lois-search-icon">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#9ca3af" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <circle cx="11" cy="11" r="8"></circle>
                                <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
                            </svg>
                        </span>
                        <input
                            type="text"
                            value={searchInput}
                            onChange={(e) => setSearchInput(e.target.value)}
                            placeholder="Rechercher un article de loi, un code, une référence..."
                            className="lois-search-input"
                        />
                        <button type="submit" className="lois-search-btn">
                            Rechercher
                        </button>
                    </form>
                </div>

                <div className="lois-header-right">
                    <button className="lois-login-btn" onClick={handleLogin}>
                        Se connecter
                    </button>
                </div>
            </header>

            {/* Filters & Content */}
            <div className="lois-body">
                {currentQuery && (
                    <>
                        <FiltreLois />

                        <div className="lois-tag-list">
                            {filters.map((filter) => (
                                <button
                                    key={filter}
                                    className={`lois-tag ${activeFilter === filter ? "active" : ""}`}
                                    onClick={() => handleFilterClick(filter)}
                                >
                                    {filter}
                                </button>
                            ))}
                        </div>
                    </>
                )}

                <div className="lois-results-container">
                    {loading ? (
                        <div className="lois-loading">
                            <div className="lois-spinner"></div>
                            <p>Chargement des résultats...</p>
                        </div>
                    ) : currentQuery ? (
                        searchData.results.length > 0 ? (
                            <Loiresults
                                data={searchData}
                                searchQuery={currentQuery}
                                onPageChange={handlePageChange}
                            />
                        ) : (
                            <div className="lois-no-results">
                                <p>Aucun résultat trouvé pour votre recherche.</p>
                                <p>
                                    Essayez de modifier vos critères de recherche ou d'utiliser
                                    des termes plus généraux.
                                </p>
                            </div>
                        )
                    ) : (
                        <NoLoisResult
                            onFilterClick={handleFilterClick}
                            legalCategories={legalCategories}
                            currentPage={legalCategoriesPage}
                            onPageChange={handleCategoriesPageChange}
                            loading={legalCategoriesLoading}
                        />
                    )}
                </div>
            </div>
        </div>
    );
};

export default AllLoiResults;